<script lang="ts" context="module">
    export interface ProjectPreview {
        id: number;
        title: string;
        image: string;
        url: string;
        date: string;
    }

    export type Project = ProjectPreview & {
        id: number;
        title: string;
        startdate: string;
        enddate: string;
        bodyhtml: string;
        image: string;
        url: string;
        projectcategoryid: number;
        hidden: boolean;
    };
    export enum ProjectCateories {
        LEITSTELLE = 1,
        WACHEN_ELW = 2,
        ALARMIERUNG = 3,
        SPRACH_DATENFUNK = 4,
    }
</script>

<script lang="ts">
    import { children } from "svelte/internal";
    import Animate from "./Animate.svelte";
    import Btn from "./Btn.svelte";
    import Subline from "./Subline.svelte";
    import { t } from "../helpers/translation";
    export let show_empty_message: boolean = true;
    export let url_base: string = "/";
    export let button_text: string = "zum Projekt";
    export let headline: string = "Unsere Referenzen";
    export let data_callback: () => Promise<ProjectPreview[]>;
</script>

{#await data_callback()}
    {$t("fetch.posts.loading")}
{:then previews}
    {#if previews.length > 0}
        <Subline>{headline}</Subline>
    {/if}
    <Animate fade_up delay_each={0.05} children=".project-preview">
        <div class="project-preview-wrapper">
            {#if previews.length == 0 && show_empty_message}
                {$t("fetch.posts.empty")}
            {/if}
            {#each previews as project}
                <div class="project-preview">
                    <img
                        src={project.image ||
                            "https://liveicom.azureedge.net/sinus/img/defaults/sinus_placeholder_dark.svg"}
                        alt="projekt preview"
                    />
                    <div class="content">
                        <h3>{project.title}</h3>
                        <div class="sub-info">
                            <Btn
                                href={`${url_base}/${project.id}/${project.url}`}
                                size=".75em"
                                padding=".5em 1em"
                                arrow
                                yellow>{button_text}</Btn
                            >
                            <time>{project.date}</time>
                        </div>
                    </div>
                </div>
            {/each}
        </div>
    </Animate>
{:catch}
    {$t("fetch.posts.error")}
{/await}

<style lang="scss">
    @import "./src/vars";

    .project-preview-wrapper {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2em;
        @media (max-width: 950px) {
            font-size: 0.8rem;
        }
        @media (max-width: 800px) {
            grid-template-columns: 1fr;
            font-size: 0.9rem;
        }
        @media (max-width: 500px) {
            font-size: 0.6rem;
        }
        .project-preview {
            padding: 1.5em;
            border-radius: 0.5em;
            @media (max-width: 600px) {
                grid-template-columns: 1fr;
            }
            background-color: $grayDark2;
            :global(body.light) & {
                background-color: $grayLight2;
                // border: 1px solid var(--themeTextColor);
            }
            display: flex;
            img {
                width: 4em;
                height: 4em;
                object-fit: cover;
                margin-right: 1em;
                border-radius: 0.5em;
            }
            .content {
                flex-grow: 1;
                h3 {
                    font-size: 1.3em;
                    font-weight: 500;
                    line-height: 1.2;
                    margin-top: 0;
                    margin-bottom: 0.2em;
                    color: $yellow;
                    :global(body.light) & {
                        color: $grayDark2;
                    }
                }
                .sub-info {
                    display: flex;
                    align-items: center;
                    gap: 1em;
                    justify-content: space-between;
                }
                time {
                    font-size: 1em;
                    color: var(--themeTextColor);
                    font-weight: 300;
                }
            }
        }
        &:global(.btn) {
            margin: 0 !important;
        }
    }
</style>
